<template>
  <router-view></router-view>
</template>

<script>
export default {
  components: {},
};
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: #dbdbdb;
  font-family: "Noto Sans TC", sans-serif;
}
</style>
